import { combineReducers } from 'redux';

import { loadingStateReducer } from 'redux/utils';
import { SUBMIT_SALESFORCE_TICKET } from './constants';

export default combineReducers({
  loadingState: loadingStateReducer([SUBMIT_SALESFORCE_TICKET])
});
